import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

import { env as authEnv } from "@acme/modern-auth/env";
import { env as queueEnv } from "@acme/queue/env";

import { env as octokitEnv } from "./utils/octokit/octokit-env";

export const env = createEnv({
  extends: [queueEnv, authEnv, octokitEnv],
  server: {
    REDIS_URL: z.string(),
    SST_TRPC_URL: z.string(),
    STRIPE_SECRET_KEY: z.string(),
    TRPC_SIGNING_SECRET: z.string(),
    APP_PUBLIC_URL: z.string(),
    ENCRYPTION_KEY: z.string(),
  },
  client: {},
  experimental__runtimeEnv: {},
  skipValidation:
    !!process.env.CI || process.env.npm_lifecycle_event === "lint",
});
